import {
	SET_ORDER_RETURN_DATA,
    SET_TABS_COUNT,
	UPDATE_SHIMMER,
	SET_SEARCH_RETURN_DATA,
	RESET_SEARCH_DATA,
	VIEW_CLAIM_DATA,
	UPDATE_SELECTED_FILTER,
	REMOVE_SELECTED_FILTER
} from '../actions/types';

const initialState = {
	tabsCount: [],
    orderData:[],
	searchData: [],
	showShimmer: true,
	viewClaimData: {},
	filterList: {},
	selectedTabKey: '',
	pageNo: 1,
};
export default (state = initialState, action) => {
	switch (action.type) {
		case SET_TABS_COUNT: {
			let oldTabs = state.tabsCount;
			let tabsData = action.payload.tabs;
			if(action.payload.isFilter){
				const activeTabKey = action.payload.activeTabKey
				oldTabs = oldTabs.map((cur,index)=>{
					if(cur.key == activeTabKey){
						cur = tabsData[index]
					};
					return cur;
				})
				tabsData = oldTabs;
			}
			return {
				...state,
				tabsCount: tabsData
			}
		};
        case SET_ORDER_RETURN_DATA: {
			let oldResultData = action.payload.pageNo == 1 ? [] : state.orderData
			let newArr = []
			action.payload.order_summary.map((cur,index)=>{
				let obj = cur.order_data;
				newArr= [...newArr, ...obj];
			})
            return {
				...state,
                orderData: oldResultData.concat(action.payload.order_summary),
				allResultsFetched : newArr.length < 25,
				showShimmer: false
            }
        }
		case SET_SEARCH_RETURN_DATA:{
			let oldResultData = action.payload.pageNo == 1 ? [] : state.searchData
            return {
                ...state,
                searchData: oldResultData.concat(action.payload.order_summary),
            }
		}
		case RESET_SEARCH_DATA:{
			return {
                ...state,
                searchData: []
            }
		}
		case UPDATE_SHIMMER:{
			return {
				...state,
				showShimmer: true,
				selectedTabKey: action.payload
			}
		}
		case VIEW_CLAIM_DATA:{
			return {
				...state,
				viewClaimData: action.payload.results.data && action.payload.results.data.length && action.payload.results.data[0]
			}
		}
		case UPDATE_SELECTED_FILTER: {
			let filterObj = {...state.filterList};
			if(action.payload.filter.date){
				filterObj.date = {...action.payload.filter.date}
				delete action.payload.filter.date
			}
            filterObj[action.payload.key] = {...action.payload.filter};
			return {
				...state,
				filterList: filterObj
			}
		}
		case REMOVE_SELECTED_FILTER: {
			let filterObj = {...state.filterList};
			filterObj = {}
			return {
				...state,
				filterList: filterObj
			}
		}
		default:
			return state;
	}
};
